export const ID_ACTIVE_BAR = 'active-bar';